import { Category, ReactionType } from '../../../services/category-service';

export const isWithVotes = (reactionType?: Category['reactionType']) =>
  reactionType === ReactionType.VOTE;
